<template>
  <v-app>
    <header style="z-index: 3">
      <v-app-bar style="background: white !important">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
        <a
          href="/"
          style="
            background: #5faf4b url(/assets/img/logo.png) no-repeat 50% 12px;
            color: #111;
            position: absolute;
            text-indent: -999em;
            top: 0;
            background-position-y: 28px;
            background-size: 62px auto;
            bottom: -56px;
            left: 64px;
            width: 90px;
          "
        >
        </a>
        <a
          href="/"
          class="pl-16 mx-16"
          style="color: black; font-weight: bold; font-size: 30px"
        >
          SELBEG.MN
        </a>
        <v-text-field
          label="Үйлдвэрлэгч, ангилал зэргээр хайлт хийх"
          dense
          append-icon="mdi-magnify"
          class="pt-8"
          outlined
        ></v-text-field>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="ml-10">
              <v-col>
                <p class="mb-n1" style="font-size: 14px">Миний бүртгэл</p>
                <SUBTITLE-2 style="font-size: 14px; color: #757575"
                  >Сайн уу!, Нэвтрэх</SUBTITLE-2
                >
              </v-col>
            </div>
          </template>

          <v-list>
            <div class="ma-5" style="width: 20rem">
              <center>Account</center>
              <v-img src="assets/images/avatar.svg" class="mt-2"></v-img>
              <v-btn class="green darken-1 mt-2" style="width: 100%"
                >SIGN IN</v-btn
              >
              <v-row class="mt-2">
                <div style="display: flex; align-item: center; justify-item">
                  <span class="center">New Customer?</span>
                  <a href="" class="center">Sign Up</a>
                </div>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-btn icon class="center">
                    <v-icon>mdi-account-circle</v-icon>
                  </v-btn>
                  <p>Account</p>
                </v-col>
                <v-col cols="4">
                  <v-btn icon class="center">
                    <v-icon>mdi-check-circle-outline</v-icon>
                  </v-btn>
                  <p>Orders</p>
                </v-col>
                <v-col cols="4">
                  <v-btn icon class="center">
                    <v-icon>mdi-heart-outline</v-icon>
                  </v-btn>
                  <p>Wishlists</p>
                </v-col>
              </v-row>
            </div>
          </v-list>
        </v-menu>
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="ml-10">
              <v-row
                style="border-left: 1px solid black; max-height: 30px"
                class="pl-8"
              >
                <v-icon class="mt-n4">mdi-garage-open-variant</v-icon>
                <p class="pl-1 pt-1">Миний граж</p>
              </v-row>
            </div>
          </template>

          <v-list>
            <div class="ma-5">
              <v-cols>
                <v-col>
                  <v-btn
                    color="primary"
                    dark
                    class="rounded-pill"
                    style="width: 100%"
                    >ADD VEHICLE</v-btn
                  >
                </v-col>
                <v-col>
                  <v-row>
                    <v-icon>mdi-garage-variant</v-icon>
                    <p class="pt-4 ml-1">Store vehicles in your garage</p>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <v-icon>mdi-lightbulb-on-outline</v-icon>
                    <p class="pt-4 ml-1">Get product recommendations</p>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <v-icon>mdi-cog-outline</v-icon>
                    <p class="pt-4 ml-1">Easily find parts & accessories</p>
                  </v-row>
                </v-col>
              </v-cols>
            </div>
          </v-list>
        </v-menu>
        <v-btn
          style="font-size: 15px; text-transform: none"
          color="#A8101F"
          dark
          class="ml-8"
          >Сэлбэг нэмэх</v-btn
        >
        <template v-slot:extension>
          <v-tabs centered color="white" optional class="navmenu">
            <v-tab
              @click="
                $router.push({
                  name: 'CategoryItems',
                  params: { categoryId: category.id },
                })
              "
              class="px-7 black--text"
              style="
                font-weight: bold;
                text-transform: none;
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 21px;
                letter-spacing: 0px;
              "
              v-for="category in selbegtypes"
              :key="'menu-' + category.id"
            >
              {{ category.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </header>
    <v-main>
      <router-view />
    </v-main>
    <footer>
      <section style="background: #363d47">
        <v-container>
          <v-row justify="space-around">
            <v-col lg="3" md="3" cols="12">
              <div style="border-right: 2px solid white">
                <v-list color="transparent" dark>
                  <v-list-item>
                    <v-img
                      src="/assets/img/footicon1.png"
                      max-width="60"
                    ></v-img>
                    <v-list-item-content class="ml-3">
                      <v-list-item-title style="font-size: 20px"
                        >Тусламж</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 14px"
                        class="font-weight-light"
                        >Техникийн тусламж</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <div style="border-right: 2px solid white">
                <v-list color="transparent" dark>
                  <v-list-item>
                    <v-img
                      src="/assets/img/footicon2.png"
                      max-width="60"
                    ></v-img>
                    <v-list-item-content class="ml-3">
                      <v-list-item-title style="font-size: 20px"
                        >Бүртгэл</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 14px"
                        class="font-weight-light"
                        >Хэрэглэгчийн бүртгэл</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <div class="line">
                <v-list color="transparent" dark>
                  <v-list-item>
                    <v-img
                      src="/assets/img/footicon3.png"
                      max-width="60"
                    ></v-img>
                    <v-list-item-content class="ml-3">
                      <v-list-item-title style="font-size: 20px"
                        >Сурталчилгаа</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 14px"
                        class="font-weight-light"
                        >Сурталчилгааны байршуулах</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section>
        <v-container>
          <v-row>
            <v-col lg="3" md="3" cols="6">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="color: #817e7e"
                      >БИДНИЙ ТУХАЙ</v-list-item-title
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Компанийн тухай</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Эрхэм зорилго үнэт зүйлс</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Сайтын бүтэц</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col lg="3" md="3" cols="6">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="color: #817e7e"
                      >БИДНИЙ ҮЙЛЧИЛГЭЭ</v-list-item-title
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Үйлчилгээний нөхцөл</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Баннер байршуулах</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Хувийн дэлгүүр</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title
                      style="color: #817e7e"
                      class="text-uppercase"
                      >Хаяг байршал</v-list-item-title
                    >
                    <v-list-item-subtitle class="mt-4"
                      >СБД, 11-р хороо 7-р хороолол,<br />
                      Pro One оффис 909 тоот, 14180</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Утас: 77443355</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="mt-4"
                      >info@selbeg.mn</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col lg="3" md="3" cols="12">
              <v-list>
                <v-list-item>
                  <v-list-item-content class="text-end">
                    <v-list-item-title style="color: #817e7e"
                      >SELBEG.MN</v-list-item-title
                    >
                    <v-list-item-subtitle class="mt-4"
                      >Гэр утасны хувилбар татах</v-list-item-subtitle
                    >
                    <v-list-item-action>
                      <v-row justify="end">
                        <v-img
                          style="cursor: pointer"
                          @click="_appto('playstore')"
                          src="/assets/img/Google-Play.png"
                          max-width="120"
                        ></v-img>

                        <v-img
                          style="cursor: pointer"
                          @click="_appto('appstore')"
                          src="/assets/img/App-Store.png"
                          max-width="120"
                        ></v-img>
                      </v-row>
                    </v-list-item-action>
                    <v-list-item-action class="mt-8">
                      <v-row justify="end" class="mr-2">
                        <v-btn icon>
                          <v-img src="/assets/img/Facebook.png"></v-img>
                        </v-btn>
                        <v-btn icon class="mx-5">
                          <v-img src="/assets/img/Twitter.png"></v-img>
                        </v-btn>
                        <v-btn icon class="mr-4">
                          <v-img src="/assets/img/Instagram.png"></v-img>
                        </v-btn>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section style="background-color: #e6e6e6">
        <v-container>
          <span class="pl-4" style="font-size: 10.5pt; color: #817e7e"
            >©2020 SELBEG.MN</span
          >
        </v-container>
      </section>
    </footer>
  </v-app>
</template>

<style>
@media screen and (max-width: 960px) {
  .line {
    border-right: 2px solid white;
  }
}
@media only screen and (max-width: 1100px) {
  .navmenu {
    display: none;
  }
}
</style>
<script>
const fb = require("./firebaseConfig.js");
export default {
  name: "App",

  data: () => ({
    selbegtypes: null,
    navmenu: [
      "Гадна бие",
      "Хөдөлгүүр",
      "Явах эд анги",
      "Салон",
      "Цахилгаан",
      "Дугуй обуд",
      "Тоноглол",
      "Багаж тосолгоо",
      "Задаргаа",
    ],
  }),
  methods: {
    _appto(key) {
      if (key == "appstore") {
        window.open("https://apps.apple.com/us/app/selbeg-mn/id1521204312");
      } else if (key == "playstore") {
        window.open(
          "https://play.google.com/store/apps/details?id=mn.selbeg&hl=en&gl=US"
        );
      }
    },
  },
  created() {
    fb.db
      .collection("selbegtypes")
      .orderBy("createdAt", "asc")
      .get()
      .then((docs) => {
        this.selbegtypes = [];
        docs.forEach((doc) => {
          let selbegtype = doc.data();
          selbegtype.id = doc.id;
          selbegtype.ref = doc.ref;
          console.log(selbegtype.name);
          this.selbegtypes.push(selbegtype);
        });
      });
  },
};
</script>
